export default __webpack_public_path__ + "static/thumb-audio2-41f0a9e4629e9d3a67920dc868d8ebbd.png";